import React from "react"

import Logo from "../assets/svg/award-logo.svg"

export default ({
  headline,
  isLive,
}: {
  headline: string
  isLive?: string
}) => {
  return (
    <>
      <div className="top-logo">
        <Logo />
      </div>

      <div className="headline-wrapper">
        <h1>{headline}</h1>
        <h2>
          December 3
          <br />
          6PM CET
        </h2>
      </div>
    </>
  )
}
